import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { sidebarMenuItems } from "../data/menu";

const SidebarMenu = () => {
  const [Menu, setMenu] = useState(sidebarMenuItems);
  const location = useLocation();

  useEffect(() => {
    let arr = [...Menu];
    let item = arr.find((item) => item.active === true);
    let loc = location.pathname.split("/")[3];
    if (!item) return;
    if (item.name === loc || (!loc && item.name === "Dashboard")) return;

    let i = arr.indexOf(item);
    item.active = false;
    arr.splice(i, 1, item);

    if (!loc) item = arr.find((item) => item.name === "Dashboard");
    else item = arr.find((item) => item.name === loc);

    if (item) {
      i = arr.indexOf(item);
      item.active = true;
      arr.splice(i, 1, item);
    }

    setMenu([...arr]);
  }, [location.pathname]);

  const sethoveron = (item, index, setto) => {
    let arr = [...Menu];
    if (item.hoverOn !== setto) {
      item.hoverOn = setto;
      arr.splice(index, 1, item);
      setMenu([...arr]);
    }
  };

  const [hoverOn, setHoverOn] = useState(null);

  useEffect(() => {
    const t = Menu.find((item) => item.hoverOn);
    setHoverOn(t || null);
  }, [Menu]);

  const subMenuItems = hoverOn?.subMenu?.map((item, index) => (
    <li key={index}>
      <Link to={item.to}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-grid"
        >
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
        </svg>
        {item.name}
      </Link>
    </li>
  ));

  return (
    <SimpleBar className="no-print">
      <div className="sidebar-wrapper sidebar-theme">
        <nav id="compactSidebar">
          <ul className="menu-categories">
            {Menu?.map((item, index) => (
              <li
                key={index}
                className="menu"
                onMouseEnter={() => sethoveron(item, index, true)}
                onMouseLeave={() => sethoveron(item, index, false)}
              >
                <Link
                  to={item.to}
                  data-active={`${item?.active}`}
                  className="menu-toggle"
                >
                  <div className="base-menu">
                    <div className="base-icons">{item.icon}</div>
                    <span>{item.name.toUpperCase()}</span>
                  </div>
                </Link>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-chevron-left"
                >
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </li>
            ))}
          </ul>
        </nav>

        <div
          id="compact_submenuSidebar"
          className={`submenu-sidebar ${
            hoverOn?.subMenu?.length > 0 ? "show" : ""
          }`}
        >
          <div className="submenu">
            <ul className="submenu-list">{subMenuItems}</ul>
          </div>
        </div>
      </div>
    </SimpleBar>
  );
};

export default SidebarMenu;
